import React from "react";
import "./navbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightArrowLeft,
  faCog,
  faFileAlt,
  faList,
  faListAlt,
  faListCheck,
  faUserPlus,
  faVial,
  faBuildingFlag,
  faWarehouse,
  faCity,
  faArrowsDownToPeople,
  faRectangleList,
  faFlaskVial,
  faBoxesStacked,
  faCartPlus,
  faRightToBracket,
  faRightFromBracket,
  faFileContract,
  faVialCircleCheck,
  faHandPointer,
  faDolly,
  faListOl,
  faTags,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import IconNavbar from "./IconNavbar";
const Navbar = () => {
  return (
    <nav className="navbar-menu" role="navigation">
      <ul>
        <li className="navbar-menu__li">
          <IconNavbar title="Admin." icon={faCog} />
          <ul className="dropdown">
            <li>
              <Link className="margin-auto" to="/security/users">
                <FontAwesomeIcon className="cursor-pointer" icon={faUserPlus} />
                &nbsp; Usuarios
              </Link>
            </li>
            <li>
              <Link className="margin-auto" to="/inventory/warehouse">
                <FontAwesomeIcon className="cursor-pointer" icon={faWarehouse} />
                &nbsp; Almacenes
              </Link>
            </li>
            <li>
              <Link className="margin-auto" to="/inventory/providers">
                <FontAwesomeIcon className="cursor-pointer" icon={faCity} />
                &nbsp; Proveedores
              </Link>
            </li>
          </ul>
        </li>
        <li className="navbar-menu__li">
          <IconNavbar title="Artículos" icon={faVial} />

          <ul className="dropdown">
            <li>
              <Link className="margin-auto" to="/inventory/articles">
                <FontAwesomeIcon className="cursor-pointer" icon={faRectangleList} />
                &nbsp; Lista de artículos
              </Link>
            </li>
            <li>
              <Link className="margin-auto" to="/inventory/article/null">
                <FontAwesomeIcon className="cursor-pointer" icon={faTags} />
                &nbsp; Maestro de artículos
              </Link>
            </li>
            <li>
              <Link className="margin-auto" to="/inventory/articlesbywarehouse">
                <FontAwesomeIcon className="cursor-pointer" icon={faBoxesStacked} />
                &nbsp; Inventario
              </Link>
            </li>
          </ul>
        </li>
        <li className="navbar-menu__li">
          <IconNavbar title="Kits" icon={faFlaskVial} />
          <ul className="dropdown">
            <li>
              <Link className="margin-auto" to="/inventory/tests">
                <FontAwesomeIcon className="cursor-pointer" icon={faListCheck} />
                &nbsp; Gestión de kits
              </Link>
            </li>
            <li>
              <Link className="margin-auto" to="/inventory/tests-active">
                <FontAwesomeIcon className="cursor-pointer" icon={faCartPlus} />
                &nbsp; Consumos de kits
              </Link>
            </li>
          </ul>
        </li>
        <li className="navbar-menu__li">
          <IconNavbar title="Movimientos" icon={faArrowRightArrowLeft} />
          <ul className="dropdown">
            <li>
              <Link className="margin-auto" to="/inventory/entry">
                <FontAwesomeIcon className="cursor-pointer" icon={faRightToBracket} />
                &nbsp; Nueva entrada
              </Link>
            </li>
            <li>
              <Link className="margin-auto" to="/inventory/entries">
                <FontAwesomeIcon className="cursor-pointer" icon={faListOl} />
                &nbsp; Lista entradas
              </Link>
            </li>
            
            <li className="navbar__submenu">

              <a className="margin-auto">
                <FontAwesomeIcon className="cursor-pointer" icon={faRightFromBracket} />
                &nbsp; Nueva salida
              </a>
              <ul className="dropdown__submenu">
                <li>
                  <Link className="margin-auto" to="/inventory/tests-active">
                    <FontAwesomeIcon className="cursor-pointer" icon={faVialCircleCheck} />
                    &nbsp; Salida kits
                  </Link>
                </li>
                <li>
                  <Link className="margin-auto" to="/inventory/handOut">
                    <FontAwesomeIcon className="cursor-pointer" icon={faHandPointer} />
                    &nbsp; Salida manual
                  </Link>
                </li>
              </ul>
            </li>

            <li>
                  <Link className="margin-auto" to="/inventory/handOuts">
                    <FontAwesomeIcon className="cursor-pointer" icon={faListOl} />
                    &nbsp; Lista salidas
                  </Link>
                </li>

            <li>
              <Link className="margin-auto" to="/inventory/articles">
                <FontAwesomeIcon className="cursor-pointer" icon={faFileContract} />
                &nbsp; Reporte
              </Link>
            </li>

          </ul>
        </li>

      </ul>
    </nav>
  );
};

export default Navbar;
